function fnTestimonialsSliderAlt(i, oSection) {
  //const startFrom = oSection.getAttribute('data-start')

  const imageSwiper = new Swiper(
    oSection.querySelector(".image-swiper .swiper"),
    {
      effect: "cards",
      cardsEffect: {
        slideShadows: false,
				perSlideRotate: 4,
				perSlideOffset: 10
      },
      allowTouchMove: false,
    }
  );

  const contentSwiper = new Swiper(
    oSection.querySelector(".content-swiper .swiper"),
    {
      autoHeight: true,
      spaceBetween: 30,
      navigation: {
        nextEl: oSection.querySelector(".arrows .next"),
        prevEl: oSection.querySelector(".arrows .prev"),
      },
      pagination: {
        el: oSection.querySelector(".progress-bar"),
        type: "progressbar",
      },
      autoplay: {
        delay: 5000
      },
      controller: {
        control: imageSwiper
      },
    }
  );
}
